import React from "react";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../data/mock";

export default function FinalCTA() {
  return (
    <section className="px-5 py-20 md:px-10 md:py-24">
      <div className="mx-auto max-w-[820px] text-center">
        <h2 className="font-serif-display text-[38px] leading-[1.1] text-[#0e1a2b] md:text-[54px]">
          Não perca a chance de reaver o que foi pago a maior.
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-[14.5px] leading-relaxed text-[#54657a]">
          Envie uma mensagem direta pelo WhatsApp. Em até 1 dia útil você recebe uma
          análise inicial do seu caso, sem compromisso.
        </p>
        <div className="mt-9">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2.5 rounded-md bg-[#16a34a] px-7 py-4 text-[15px] font-medium text-white shadow-lg shadow-[#16a34a]/20 transition hover:bg-[#15803d]"
          >
            <MessageCircle className="h-5 w-5" strokeWidth={2.6} />
            Falar com um especialista agora
          </a>
        </div>
      </div>
    </section>
  );
}
